"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var useStyles = (0, styles_1.makeStyles)(function (theme) {
  return {
    active: {
      color: theme.palette.primary.main,
      fontWeight: 'bold'
    },
    link: __assign(__assign({}, theme.typography.caption), {
      margin: '0 auto',
      textAlign: 'center'
    }),
    paginator: {
      color: theme.palette.text.secondary,
      display: 'flex',
      '& li': {
        display: 'inline-block',
        flex: 1,
        margin: theme.spacing(2),
        ' & a': {
          cursor: 'pointer'
        }
      },
      overflowX: 'scroll',
      padding: 0,
      width: '100%'
    },
    searchField: {
      width: '85%'
    },
    section: {
      marginTop: theme.spacing(5),
      textAlign: 'center'
    }
  };
});
exports.default = useStyles;